@import '../../../../../static/less/variables';

.vertical-modal {
  &.modal {
    text-align: center;
    padding: 0 !important;
  }

  &.modal:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-right: -4px;
  }

  .modal-dialog {
    display: inline-block;
    text-align: left;
    vertical-align: middle;
    margin: 30px 0;
  }
}

@media screen and (max-width: @screen-xs-max) {
  .vertical-modal {
    .modal-dialog {
      &.modal-sm {
        min-width: 100%;
      }
    }
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/components/Upsell/Popups/PopupExperiment.less